import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { Formik } from "formik";
import * as Yup from "yup";
import toastr from "toastr";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import {
  getSancionesDocs,
  saveSancionesDoc,
  editSancionesDoc,
  deleteSancionesDoc,
} from "../../../redux/Modulo_Sanciones/formatos/actions";

import messages from "../../../redux/messages";
// import SidebarBoarding from "../../../components/OnBoarding_OffBoarding/sidebar_On_Off_Boarding";
import SidebarBoarding from "../../../components/SidebarDashboard";
import config from "../../../config";
import LinkDescargaListGD from "../../../components/gestorDocumental/LinkDescargaListGD";
import LinkDescargaGD from "../../../components/gestorDocumental/LinkDescargaGD";
import {
  getAreas,
  getCarpetas,
  getSubNivelesSancionesDocs,
} from "../../../redux/gestorDocumental/actions";
import { getBase64 } from "../../../components/gestorDocumental/GestorDocumental";
// import { getPersonalDivision } from '../../../redux/divisionPersonal/actions';
// import { getOrgs } from '../../../redux/organization/actions';

const schema = Yup.object().shape({
  // area: Yup.string().when('isEdit',{
  //   is: false,
  //   then: Yup.string().required('**Campo requerido')
  // }),
  // carpeta: Yup.string().when('isEdit',{
  //   is: false,
  //   then: Yup.string().required('**Campo requerido')
  // }),
  // medidas_disciplinarias: Yup.string().when("isEdit", {
  //   is: false,
  //   then: Yup.string().required("**Campo requerido"),
  // }),
  /*tipoDocumento: Yup.string().required('**Campo requerido'),
  descripcionDoc: Yup.string().required('**Campo requerido'),
  empresa: Yup.string().required('**Campo requerido'),
  division: Yup.string().required('**Campo requerido'),*/
  nombre: Yup.string()
    .matches(/[\w]/, "Formato no correcto")
    .required("**Campo requerido"),
  descripcion: Yup.string()
    .matches(/[\w]/, "Formato no correcto")
    .required("**Campo requerido"),
  subnivel1: Yup.string().when("isEdit", {
    is: false,
    then: Yup.string().required("**Campo requerido"),
  }),
  subnivel2: Yup.string().when("isEdit", {
    is: false,
    then: Yup.string().required("**Campo requerido"),
  }),
  archivo: Yup.mixed().when("isEdit", {
    is: false,
    then: Yup.mixed()
      .required("**Campo requerido")
      .test(
        "fileSize",
        "**El archivo es demasiado grande, es requerido un archivo menor o igual a 200 megabytes",
        (file) => (file ? !(file.size / 1024 > 200000) : false)
      ),
  }),
});

const DocsSanciones = (props) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [enableEdit, setEnableEdit] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Nombre",
  });

  const { userId, userRoles } = useSelector((store) => store.auth);
  //division
  // const personalDivision = useSelector(store => store.divisionPersonal.divisionPersonal);
  // const personalDivisionLoader = useSelector(store => store.divisionPersonal.loading);
  // const dataOrg = useSelector(store => store.orgs.orgs);
  // const loadingOrg = useSelector(store => store.orgs.loading);
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    loadingAreas,
    loadingCarpetas,
    loaderSubNiveles,
    areas,
    carpetas,
    subNiveles,
    subNivelesError,
  } = useSelector((store) => store.gestorDocumental);

  //* variables
  const { sansionesFormatos, email } = config.gestorDocumental;

  const filters = [
    { id: "nombre", desc: "Nombre" },
    { id: "descripcion", desc: "Descripción" },
  ];

  const { loaderDocs, saveLoaderDoc, docs, docsFaild, formDocsFaild } =
    useSelector((store) => store.sancionesDocs);

  const pages = Math.ceil((docs ? docs.count : 0) / limit);

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Descripcion",
      accessor: "descripcion",
    },
    {
      Header: "Creado por",
      Cell: (value) =>
        `${value.row.original.list_creado_por[0].first_name} ${value.row.original.list_creado_por[0].last_name}`,
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          {userRoles.length > 0 &&
            (userRoles.includes("Responsable_Sanciones") ||
              userRoles.includes("Encargado_Sanciones") ||
              userRoles.includes("administrador")) && (
              <>
                <Button
                  size="sm"
                  variant="link"
                  type="button"
                  onClick={() => onEdit(value.row.original, value.row.index)}
                >
                  <i className="material-icons">edit</i>
                </Button>
                <Button
                  size="sm"
                  className="text-danger"
                  variant="link"
                  type="button"
                  onClick={() =>
                    onDelete(value.row.original.id, value.row.index)
                  }
                >
                  <i className="material-icons">close</i>
                </Button>
              </>
            )}
          <LinkDescargaListGD
            id={value.row.original.list_archivo[0].id}
            filters={{
              email: email,
              id: value.row.original.list_archivo[0].id_documento,
              llave: value.row.original.list_archivo[0].llave,
            }}
            origen={value.row.original.list_archivo[0].origen}
            cType={value.row.original.list_archivo[0].contentTypeGD}
          />
        </div>
      ),
    },
  ];

  // Métodos
  const _getSancionesDocs = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getSancionesDocs({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter: filt,
      })
    );

  useEffect(() => {
    if (userRoles.length > 0) {
      if (
        userRoles.includes("Responsable_Sanciones") ||
        userRoles.includes("Encargado_Sanciones") ||
        userRoles.includes("administrador")
      ) {
        dispatch(getAreas());
        dispatch(getCarpetas());
        setEnableEdit(true);
      }
    }
    // dispatch(getAreas());
    // dispatch(getCarpetas());
    _getSancionesDocs();
    // dispatch(getPersonalDivision({}, 2));
    // dispatch(getOrgs(2));
  }, [props.match.params.type, userRoles]);

  useEffect(() => {
    if (areas && areas.length > 0 && carpetas && carpetas.length > 0) {
      const oCarpeta = carpetas.find(
        (item) =>
          item.descripcion.toLowerCase() ===
          sansionesFormatos.carpeta.toLowerCase()
      );
      dispatch(
        getSubNivelesSancionesDocs({
          areaid: parseInt(areas[0].id),
          ceid: parseInt(oCarpeta.id),
        })
      );
    }
  }, [areas, carpetas]);

  const addArea = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getSancionesDocs(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (values) => {
    try {
      let reqDoc = null;
      if (values.archivo) {
        const oCarpeta = carpetas.find(
          (item) =>
            item.descripcion.toLowerCase() ===
            sansionesFormatos.carpeta.toLowerCase()
        );
        const filebase64 = await getBase64(values.archivo);
        const fileName = values.archivo.name;
        const fName = String(fileName)
          .substring(0, String(fileName).lastIndexOf("."))
          .replace(/\W/g, "");
        const fExt = `.${String(fileName).substr(
          fileName.lastIndexOf(".") + 1 - fileName.length
        )}`;
        const aFileBase = String(filebase64).split(",");
        reqDoc = {
          id_area: parseInt(areas[0].id),
          id_carpeta_encabezado: parseInt(oCarpeta.id),
          subnivel1: values.subnivel1,
          subnivel2: values.subnivel2,
          medidas_disciplinarias: "",
          //empresa: values.empresa,
          //zona: values.division,
          //tipo_documento_GD: values.tipoDocumento,
          //descripcion: values.descripcion,
          //id_empleado: 0,
          tipo_documento: sansionesFormatos.tipoDocumento,
          archivo: aFileBase[1],
          //fecha: moment().format('YYYY-MM-DD'),
          origen: fName + fExt,
          extension: fExt,
          //id_registro: 0,
          contentTypeGD: `${aFileBase[0]},`,
        };
      }
      const req = {
        reqDoc: reqDoc,
        req: {
          nombre: values.nombre,
          descripcion: values.descripcion,
          creado_por: !edit ? userId : editItem.creado_por,
        },
      };

      if (edit) {
        req.req.fecha_actualizacion = editItem.fecha_actualizacion;
        req.req.fecha_creacion = editItem.fecha_creacion;
        req.req.archivo = editItem.archivo;
        if (req.reqDoc) {
          req.reqDoc.id = editItem.list_archivo[0].id;
        }
        dispatch(editSancionesDoc(req, editItem.id, index, setShowModal));
      } else {
        dispatch(saveSancionesDoc(req, setShowModal));
      }
    } catch (error) {
      toastr.info("Error al subir archivo");
      return;
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getSancionesDocs(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteSancionesDoc(id, index));
      window.alert("Se borro este archivo");
    }
  };

  // const onGetSubNivelesList = (areaid, carpetaid) => {
  //   dispatch(getSubNivelesSancionesDocs({
  //     areaid: parseInt(areaid),
  //     ceid: parseInt(carpetaid),
  //   }));
  // }

  // const onChangeArea = (e) => dispatch(getCarpetas(parseInt(e.target.value)));

  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarBoarding show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              Formatos oficiales sanciones
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <ButtonGroup>
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                        }
                      >
                        <Dropdown className="ml-3 mr-3">
                          <Dropdown.Toggle
                            variant="light"
                            className="btn-sm font rounded-pill"
                          >
                            <i className="material-icons">filter_list</i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filters.map((item) => (
                              <Dropdown.Item
                                onClick={() => setTipoBusqueda(item)}
                                key={item.id}
                              >
                                {item.desc}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </OverlayTrigger>
                    </ButtonGroup>
                    {userRoles.length > 0 &&
                      (userRoles.includes("Responsable_Sanciones") ||
                        userRoles.includes("Encargado_Sanciones") ||
                        userRoles.includes("administrador")) && (
                        <Button
                          variant="light"
                          size="sm"
                          className="rounded-circle"
                          onClick={() => addArea()}
                        >
                          <i className="material-icons">add</i>
                        </Button>
                      )}
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {docsFaild && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {docsFaild}
            </Alert>
          )}
          {loaderDocs ? (
            <div className="d-flex justify-content-center mt-3">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : docs && docs.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={docs.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={docs.count}
                pages={pages}
                pagFunc={_getSancionesDocs}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              No se encontraron registros
            </Alert>
          )}
        </Container>
      </div>
      {userRoles.length > 0 &&
        (userRoles.includes("Responsable_Sanciones") ||
          userRoles.includes("Encargado_Sanciones") ||
          userRoles.includes("administrador")) && (
          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Formik
              validationSchema={schema}
              onSubmit={onSubmit}
              initialValues={{
                // area: edit ? editItem.id_area : '',
                // carpeta: edit ? editItem.id_carpeta_encabezado : '',
                tipoDocumento: edit ? editItem.tipo_documento_GD : "",
                // medidas_disciplinarias: edit
                //   ? editItem.medidas_disciplinarias
                //   : "",
                /*
          division: edit ? editItem.division : '',
          empresa: edit ? editItem.empresa : '',
          fechaEntrega: edit ? editItem.fecha : '',
          descripcion: edit ? editItem.descripcion : '',*/
                archivo: null,
                nombre: edit ? editItem.nombre : "",
                descripcion: edit ? editItem.descripcion : "",
                subnivel1:
                  edit &&
                  editItem.list_archivo &&
                  editItem.list_archivo.length > 0
                    ? editItem.list_archivo[0].subnivel1
                    : "",
                subnivel2:
                  edit &&
                  editItem.list_archivo &&
                  editItem.list_archivo.length > 0
                    ? editItem.list_archivo[0].subnivel2
                    : "",
                isEdit: edit,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                setFieldValue,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form onSubmit={handleSubmit} noValidate validated={validated}>
                  <Modal.Header closeButton>
                    <Modal.Title className="text-muted">
                      {edit
                        ? "Editar formato oficial sanciones"
                        : "Crear formato oficial sanciones"}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {!!subNivelesError ? (
                      <Alert variant="danger" className="my-2">
                        <p>{!!subNivelesError && subNivelesError}</p>
                      </Alert>
                    ) : null}
                    {formDocsFaild && typeof formDocsFaild !== "object" ? (
                      <Alert variant="danger" className="my-2">
                        {formDocsFaild}
                      </Alert>
                    ) : null}
                    {/* <Form.Group controlId="area">
                <Row className="align-items-end">
                  <Col sm={ loadingAreas ? '11': '12' }>
                    <Form.Label className="ml-2">Areas</Form.Label>
                    <Form.Control
                      onChange={e => {handleChange(e); onChangeArea(e);}}
                      as="select"
                      name="area"
                      className="rounded-pill"
                      value={values.area}
                      isInvalid={touched.area && !!errors.area}
                      >
                        <option className="text-muted" value="" selected disabled>Selecionar área</option>
                        {
                          areas.map(area => (
                            <option key={area.id} value={area.id}>{area.descripcion}</option>
                          ))
                        }
                    </Form.Control>

                    <Form.Control.Feedback type="invalid" className='ml-2'>
                      {errors.area}
                    </Form.Control.Feedback>
                  </Col>
                  {
                    loadingAreas && (
                      <Col sm="1">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )
                  }
                </Row>
              </Form.Group>
              <Form.Group controlId="carpeta">
                <Row className="align-items-end">
                  <Col sm={ loadingCarpetas ? '11': '12' }>
                    <Form.Label className="ml-2">Carpeta</Form.Label>
                    <Form.Control
                      onChange={e => {handleChange(e);  onGetSubNivelesList(values.area, e.target.value);}}
                      as="select"
                      disabled={loadingCarpetas}
                      name="carpeta"
                      className="rounded-pill"
                      value={values.carpeta}
                      isInvalid={touched.carpeta && !!errors.carpeta}
                      >
                        <option className="text-muted" value="" selected disabled>Selecionar carpeta</option>
                        {
                          carpetas.map(carp => (
                            <option key={carp.id} value={carp.id}>{carp.descripcion}</option>
                          ))
                        }
                    </Form.Control>

                    <Form.Control.Feedback type="invalid" className='ml-2'>
                      {errors.carpeta}
                    </Form.Control.Feedback>
                  </Col>
                  {
                    loadingCarpetas && (
                      <Col sm="1">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )
                  }
                </Row>
              </Form.Group> */}
                    {/* <Form.Group controlId="empresa">
                <Row className="align-items-end">
                  <Col sm={ loadingOrg ? '10': '12' }>
                    <Form.Label className="ml-2">Empresa</Form.Label>
                    <Form.Control
                      as="select"
                      name="empresa"
                      className="rounded-pill"
                      required
                      onChange={handleChange}
                      disabled={loadingOrg}
                      value={values.empresa}
                      isInvalid={touched.empresa && !!errors.empresa}
                      placeholder="Empresa">
                        <option className="text-muted" value="" selected disabled>Selecionar empresa</option>
                        {
                          dataOrg ? dataOrg.sort((a, b) => {
                            if(a.nombre && b.nombre){
                              if (a.nombre.toLowerCase() === b.nombre.toLowerCase()) {
                                return 0;
                              }
                              if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
                                return -1;
                              }
                            }
                            return 1;
                          }).map(item => (
                            <option key={item.id} value={item.nombre}>{item.nombre ? item.nombre.toUpperCase() : ''}</option>
                          )) : null
                        }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.empresa}
                    </Form.Control.Feedback>
                  </Col>
                  {
                    loadingOrg && (
                      <Col sm="2">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )
                  }
                </Row>
              </Form.Group>
              <Form.Group controlId="division">
                <Row className="align-items-end">
                  <Col sm={ personalDivisionLoader ? '10': '12' }>
                    <Form.Label className="ml-2">Zona</Form.Label>
                    <Form.Control
                      as="select"
                      name="division"
                      className="rounded-pill"
                      required
                      onChange={handleChange}
                      disabled={personalDivisionLoader}
                      value={values.division}
                      isInvalid={touched.division && !!errors.division}
                      placeholder="Zona">
                        <option className="text-muted" value="" selected disabled>Selecionar división</option>
                        {
                          personalDivision ? personalDivision.sort((a, b) => {
                            if(a.descripcion && b.descripcion){
                              if (a.descripcion.toLowerCase() === b.descripcion.toLowerCase()) {
                                return 0;
                              }
                              if (a.descripcion.toLowerCase() < b.descripcion.toLowerCase()) {
                                return -1;
                              }
                            }
                            return 1;
                          }).map(item => (
                            <option key={item.id} value={item.descripcion}>{item.descripcion ? item.descripcion.toUpperCase() : ''}</option>
                          )) : null
                        }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.division}
                    </Form.Control.Feedback>
                  </Col>
                  {
                    personalDivisionLoader && (
                      <Col sm="2">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )
                  }
                </Row>
              </Form.Group> */}
                    <Form.Group controlId="tipoDocumento">
                      <Row className="align-items-end">
                        <Col sm={loaderSubNiveles ? "11" : "12"}>
                          <Form.Label className="ml-2">Módulo</Form.Label>
                          <Form.Control
                            disabled={loaderSubNiveles}
                            as="select"
                            name="subnivel1"
                            className="rounded-pill"
                            value={values.subnivel1}
                            onChange={handleChange}
                            isInvalid={touched.subnivel1 && !!errors.subnivel1}
                          >
                            <option
                              className="text-muted"
                              value=""
                              selected
                              disabled
                            >
                              Selecionar módulo
                            </option>
                            {subNiveles && Array.isArray(subNiveles.module)
                              ? subNiveles.module.map((subnivel) => (
                                  <option
                                    key={subnivel.id}
                                    value={subnivel.descripcion}
                                  >
                                    {subnivel.descripcion}
                                  </option>
                                ))
                              : null}
                          </Form.Control>
                          <Form.Control.Feedback type="invalid">
                            {errors.subnivel1}
                          </Form.Control.Feedback>
                        </Col>
                        {loaderSubNiveles && (
                          <Col sm="1">
                            <Spinner animation="border" size="sm" />
                          </Col>
                        )}
                      </Row>
                    </Form.Group>
                    <Form.Group controlId="tipoDocumento">
                      <Row className="align-items-end">
                        <Col sm={loaderSubNiveles ? "11" : "12"}>
                          <Form.Label className="ml-2">
                            Tipo de archivo
                          </Form.Label>
                          <Form.Control
                            disabled={loaderSubNiveles}
                            as="select"
                            name="subnivel2"
                            className="rounded-pill"
                            value={values.subnivel2}
                            onChange={handleChange}
                            isInvalid={touched.subnivel2 && !!errors.subnivel2}
                          >
                            <option
                              className="text-muted"
                              value=""
                              selected
                              disabled
                            >
                              Selecionar tipo de archivo
                            </option>
                            {subNiveles && Array.isArray(subNiveles.files)
                              ? subNiveles.files.map((subnivel) => (
                                  <option
                                    key={subnivel.id}
                                    value={subnivel.descripcion}
                                  >
                                    {subnivel.descripcion}
                                  </option>
                                ))
                              : null}
                          </Form.Control>
                          <Form.Control.Feedback type="invalid">
                            {errors.subnivel2}
                          </Form.Control.Feedback>
                        </Col>
                        {loaderSubNiveles && (
                          <Col sm="1">
                            <Spinner animation="border" size="sm" />
                          </Col>
                        )}
                      </Row>
                    </Form.Group>
                    {/* <Form.Group controlId="descripcion">
                <Row className="align-items-end">
                  <Col sm={ loaderSubNiveles ? '11': '12' }>
                    <Form.Label className="ml-2">Descripción</Form.Label>
                    <Form.Control
                      disabled={loaderSubNiveles}
                      as="select"
                      name="descripcion"
                      className="rounded-pill"
                      value={values.descripcion}
                      onChange={handleChange}
                      isInvalid={touched.descripcion && !!errors.descripcion}
                      >
                        <option className="text-muted" value="" selected disabled>Selecionar descripción</option>
                        {
                          subNiveles ? subNiveles.subNivelDescripcionList.map(desc => (
                            <option key={desc.id} value={desc.descripcion}>{desc.descripcion}</option>
                          )) : null
                        }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.descripcion}
                    </Form.Control.Feedback>
                  </Col>
                  {
                    loaderSubNiveles && (
                      <Col sm="1">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )
                  }
                </Row>
              </Form.Group> */}
                    <Form.Group>
                      <Form.File
                        accept="image/*,application/pdf,.xlsx,.xls,.csv,.doc,.docx"
                        className="mt-2 text-left position-relative"
                        name="archivo"
                        label="Archivo"
                        onChange={(e) =>
                          setFieldValue("archivo", e.currentTarget.files[0])
                        }
                        isInvalid={touched.archivo && !!errors.archivo}
                        feedback={errors.archivo}
                        //feedbackTooltip
                      />
                      <Form.Control.Feedback type="invalid">
                        {/*  <ul className="list-unstyled">
                    <li>
                      **Es requerido un archivo de menor peso.
                    </li>
                    <li>
                      **Es requerido un archivo con formato pdf o imagen.
                    </li>
                  </ul> */}
                        {errors.archivo}
                      </Form.Control.Feedback>
                    </Form.Group>
                    {edit && (
                      <>
                        <hr />
                        <p className="ml-2 text-muted">Documento actual</p>
                        <LinkDescargaGD
                          id={editItem.list_archivo[0].id}
                          filters={{
                            email: email,
                            id: editItem.list_archivo[0].id_documento,
                            llave: editItem.list_archivo[0].llave,
                          }}
                          origen={editItem.list_archivo[0].origen}
                          cType={editItem.list_archivo[0].contentTypeGD}
                        />
                        <hr />
                      </>
                    )}
                    <Form.Group className="mb-3">
                      <Form.Label column sm="12" md="12">
                        Nombre:
                      </Form.Label>
                      <Form.Control
                        required
                        name="nombre"
                        className="rounded-pill"
                        value={values.nombre}
                        onChange={(e) => handleChange(e)}
                        isInvalid={touched.nombre && !!errors.nombre}
                        placeholder="Nombre del archivo"
                      ></Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.nombre}
                      </Form.Control.Feedback>
                      {formDocsFaild &&
                      typeof formDocsFaild === "object" &&
                      formDocsFaild.nombre ? (
                        <ul className="list-unstyled text-danger ml-2">
                          {formDocsFaild.nombre.map((item) => (
                            <li>{item}</li>
                          ))}
                        </ul>
                      ) : null}
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label column sm="12" md="12">
                        Descripción:
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        required
                        name="descripcion"
                        value={values.descripcion}
                        onChange={(e) => handleChange(e)}
                        isInvalid={touched.descripcion && !!errors.descripcion}
                        placeholder="Descripción del archivo"
                      ></Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.descripcion}
                      </Form.Control.Feedback>
                      {formDocsFaild &&
                      typeof formDocsFaild === "object" &&
                      formDocsFaild.descripcion ? (
                        <ul className="list-unstyled text-danger ml-2">
                          {formDocsFaild.descripcion.map((item) => (
                            <li>{item}</li>
                          ))}
                        </ul>
                      ) : null}
                      {formDocsFaild &&
                      typeof formDocsFaild === "object" &&
                      formDocsFaild.creado_por ? (
                        <ul className="list-unstyled text-danger ml-2">
                          {formDocsFaild.creado_por.map((item) => (
                            <li>{item}</li>
                          ))}
                        </ul>
                      ) : null}
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      className="rounded-pill"
                      variant="secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cerrar
                    </Button>
                    <Button
                      className="rounded-pill"
                      disabled={saveLoaderDoc}
                      variant="primary"
                      type="submit"
                    >
                      {saveLoaderDoc && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Guardar
                    </Button>
                  </Modal.Footer>
                </Form>
              )}
            </Formik>
          </Modal>
        )}
    </>
  );
};

export default DocsSanciones;
